export default __webpack_public_path__ + "static/media/PEP.7921d957.png";